import { connect } from 'react-redux';
import LineCommitments from './LineCommitments';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state: IApplicationState) => ({
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : '',
});

export default connect(mapStateToProps, null)(LineCommitments);
